import { render, staticRenderFns } from "./PointGmoneyConfirm.vue?vue&type=template&id=f81a1726"
import script from "./PointGmoneyConfirm.vue?vue&type=script&lang=js"
export * from "./PointGmoneyConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports